import Vue from 'vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VueAnalytics from "vue-analytics";
import router from './router';
import VueMeta from 'vue-meta';
Vue.use(VueMeta)

import App from './App.vue';


import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faMinus, faChevronRight, faPhoneSquare, faMapMarkerAlt, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faPlus, faMinus, faChevronRight, faMapMarkerAlt, faPhoneSquare, faEnvelopeOpen)
Vue.component('font-awesome-icon', FontAwesomeIcon)


import store from "./store";
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

/* load custom js files */
import './functions.js';

console.log('[i] Starting client app')

Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      apiUrl:'https://staging.cyberpunks.io/yoursource-content/'
    }
  }
})

import { SpinnerPlugin } from 'bootstrap-vue';
Vue.use(SpinnerPlugin);

//-- Initialize Google Analytics tracking.
Vue.use(VueAnalytics, {
  id: GA_TRACKING_ID,
  router
});



new Vue({

  render: h => h(App),
  router,
  store
}).$mount('#app')
